var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m100.008 11h252.241l54.724 54.724v345.044h-306.965z",
    fill: "#cfe8ff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m395.126 53.876 11.847 11.848v345.044h-11.847z",
    fill: "#b6dbff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.028 344.188h316v156.784h-316z",
    fill: "#2dd62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.283 360.602c-1.615 11.739 6.083 19.599 14 19.599v26.082h-272.511v-26.082c7.917 0 15.616-7.86 14-19.599h244.512z",
    fill: "#29b933",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.37 365.932h233.315c0 10.824 8.775 19.599 19.599 19.599v74.099c-10.824 0-19.599 8.775-19.599 19.599h-233.315c0-10.824-8.775-19.599-19.599-19.599v-74.099c10.824 0 19.599-8.775 19.599-19.599z",
    fill: "#96ff96",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.028,
    cy: 422.58,
    fill: "#29b933",
    r: 56.459,
    transform: "matrix(.178 -.984 .984 .178 -276.847 513.904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.028 366.122c30.024 0 54.57 23.437 56.351 53.014-1.781 29.577-26.327 53.014-56.351 53.014s-54.57-23.437-56.351-53.014c1.781-29.576 26.327-53.014 56.351-53.014z",
    fill: "#2dd62d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.707 344.188h7.321v156.784h-7.321z",
    fill: "#29b933"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m352.249 11 54.724 54.724h-54.724z",
    fill: "#4eb1fc",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m66.705 428.58c-3.314 0-6-2.686-6-6s2.686-6 6-6h11.865c3.314 0 6 2.686 6 6s-2.686 6-6 6zm192.782 0c-3.314 0-6-2.686-6-6s2.686-6 6-6h11.865c3.314 0 6 2.686 6 6s-2.686 6-6 6z",
    fill: "#009914",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m145.54 174.51h36.387v136.762h-36.387z",
    fill: "#4eb1fc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m81.815 238.528h36.386v72.743h-36.386z",
    fill: "#fdc72e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m209.265 185.028h36.386v126.243h-36.386z",
    fill: "#2dd62d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m272.99 135.794h36.387v175.477h-36.387z",
    fill: "#f89b00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m18.089 270.18h36.386v41.091h-36.386z",
    fill: "#fb545c"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m289.686 76.407c-3.275.479-6.318-1.788-6.797-5.062s1.788-6.318 5.062-6.797l21.269-3.114c4.046-.592 7.44 2.945 6.779 6.914l-3.097 21.151c-.479 3.275-3.522 5.541-6.797 5.062s-5.541-3.522-5.062-6.797l.493-3.367-74.178 74.179c-1.719 1.718-4.327 2.208-6.562 1.266l-59.135-25.061-118.323 118.326c-2.343 2.342-6.142 2.342-8.484 0s-2.343-6.142 0-8.484l121.167-121.167c1.913-1.913 4.797-2.264 7.067-1.052l58.63 24.847 71.336-71.337z",
    fill: "#7986bf",
    fillRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m298.584 135.794h10.793v175.477h-10.793z",
    fill: "#e68207"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m234.858 185.028h10.793v126.243h-10.793z",
    fill: "#29b933"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m171.133 174.51h10.793v136.762h-10.793z",
    fill: "#2a92fa"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m107.407 238.528h10.793v72.743h-10.793z",
    fill: "#f9ac00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m43.681 270.18h10.793v41.091h-10.793z",
    fill: "#e8333c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m169.023 467.204c-3.325 0-5.975-2.689-5.975-5.999v-4.663c-10.758-1.935-18.582-8.182-20.624-16.852-.723-3.229 1.253-6.457 4.481-7.209 3.229-.752 6.457 1.258 7.228 4.481.854 3.684 4.527 6.068 8.915 7.272v-16.615c-4.401-1.172-8.865-2.724-12.384-5.45-4.433-3.445-7.084-8.11-7.421-13.145-.386-4.915 1.445-9.715 5.06-13.517 3.738-3.872 9.1-6.105 14.745-7.014v-4.536c0-3.315 2.65-5.999 5.975-5.999s6.023 2.684 6.023 5.999v4.495c1.402.213 2.76.501 4.048.858 8.818 2.448 14.793 7.97 16.432 15.15.723 3.229-1.301 6.447-4.53 7.18-3.228.732-6.457-1.287-7.18-4.52-.867-3.893-5.831-5.667-7.951-6.25-.271-.075-.544-.145-.819-.21v17.561c.291.078.581.157.867.237 8.963 2.549 14.986 6.52 17.877 11.806 2.168 3.865 2.554 8.351 1.204 12.981-2.407 8.208-10.996 12.499-19.949 13.622v4.337c0 3.311-2.699 5.999-6.023 5.999zm-5.975-52.097v-14.412c-2.549.644-4.711 1.707-6.072 3.125-1.253 1.315-1.879 2.853-1.783 4.332.145 1.614 1.108 3.185 2.843 4.534 1.246.972 3.017 1.754 5.012 2.421zm11.998 15.663v13.986c4.69-.854 7.865-2.886 8.432-4.878.578-2.019.193-3.099-.193-3.807-1.061-1.934-4.022-3.816-8.24-5.301z",
    fill: "#009914",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m419.61 306.735c35.613 14.042 65.942 64.116 76.934 106.747 18.438 71.513-22.482 86.347-89.571 87.518-67.089-1.171-108.008-16.005-89.571-87.518 10.992-42.632 41.321-92.705 76.934-106.747h25.275z",
    fill: "#d19458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.06 500.669c-60.528-2.663-96.073-19.641-78.659-87.187 10.992-42.632 41.321-92.705 76.934-106.747h3.45c35.613 14.042 65.942 64.116 76.934 106.747 17.415 67.546-18.13 84.524-78.659 87.187z",
    fill: "#e6b17c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.866 315.359-18.255.054c-41.298-56.561-31.565-76.701-12.383-70.734 5.67 1.764 9.207 4.771 12.193 7.23 5.347 4.403 9.609 6.455 14.173-.023 9.932-14.096 18.827-14.096 28.76 0 4.564 6.478 8.826 4.426 14.173.023 2.986-2.458 6.523-5.466 12.193-7.23 19.182-5.967 28.915 14.173-12.383 70.734l-18.255-.054c-3.813.023-6.96.034-10.107.034s-6.294-.011-10.107-.034z",
    fill: "#d19458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.866 315.358-.806.003-.806-.003-1.746.01-8.361.025c-2.12 0-4.239-.005-6.562-.016-41.268-56.534-31.536-76.665-12.358-70.699 5.67 1.764 9.207 4.771 12.193 7.229 5.347 4.404 9.609 6.455 14.173-.022 9.932-14.096 18.827-14.096 28.76 0 4.564 6.477 8.826 4.426 14.173.022 1.478-1.217 3.091-2.568 5.03-3.836 5.228 8.574.196 30.022-27.02 67.305-2.323.011-4.443.016-6.562.016l-8.361-.025-1.746-.01z",
    fill: "#e6b17c"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#96602a",
    height: 20.962,
    rx: 10.481,
    width: 94.414,
    x: 359.766,
    y: 304.912
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.968 304.912h-55.722c-5.765 0-10.481 4.716-10.481 10.481s4.716 10.482 10.481 10.482h55.722c5.765 0 10.481-4.716 10.481-10.481s-4.715-10.482-10.481-10.482z",
    fill: "#ab733a",
    fillRule: "evenodd"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m400.992 459.563c-15.098-2.113-26.139-10.385-28.864-22.051-.723-3.228 1.253-6.452 4.482-7.209 3.228-.752 6.457 1.258 7.228 4.486 1.601 6.948 9.02 11.041 17.155 12.589v-28.029c-6.485-1.635-13.167-3.748-18.166-7.646-5.686-4.39-9.059-10.302-9.541-16.649-.434-6.187 1.879-12.244 6.505-17.058 5.264-5.486 13.083-8.444 21.202-9.403v-8.378c0-3.315 2.65-5.999 5.975-5.999s6.023 2.684 6.023 5.999v8.358c2.571.29 5.055.766 7.373 1.409 11.468 3.175 19.227 10.244 21.298 19.395.723 3.228-1.301 6.447-4.53 7.18-3.229.737-6.457-1.291-7.18-4.52-1.542-6.688-9.444-9.565-12.818-10.495-1.357-.376-2.744-.67-4.144-.887v29.25c.998.253 1.984.514 2.939.785 11.854 3.378 19.805 8.544 23.564 15.352 2.698 4.896 3.18 10.384 1.494 16.306-3.232 11.044-15.596 16.524-27.996 17.559v8.192c0 3.315-2.699 5.999-6.023 5.999s-5.975-2.684-5.975-5.999v-8.538zm11.998-11.688c8.456-.886 15.116-4.351 16.432-8.888.819-2.824.723-5.088-.434-7.141-2.044-3.746-7.747-7.117-15.998-9.516zm-11.998-67.204c-5.24.841-9.822 2.785-12.577 5.638-2.217 2.328-3.325 5.122-3.132 7.874.193 2.949 1.879 5.729 4.867 8.038 2.683 2.082 6.571 3.525 10.842 4.721z",
    fill: "#96602a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXero);
export default __webpack_public_path__ + "static/media/xero.b2623c67b45b88edae57603a055fb9b0.svg";
export { ForwardRef as ReactComponent };